import React, {forwardRef} from "react";
import BarcodeLabel from "../BarcodeLabel";
import PaperWidthToUse from "../BarcodeLabel/PaperWidthToUse";

const ComponentToPrintBarcodeInEditSection = forwardRef((props, refToPrintBarcode) => {
  const {submitResponse} = props;
  // //debugger
  return (
    <>
      {
        submitResponse!==undefined && submitResponse.length > 0 ?
          <div ref={refToPrintBarcode}>

            {<PaperWidthToUse
              paperWidth={submitResponse[0].paperWidth}
              barcodeLength={submitResponse[0].barcodeLength}
              barcodeWidth={submitResponse[0].barcodeWidth}
              productFont={submitResponse[0].productFont}
              barcodeCount={submitResponse[0].barcodeCount}
              priceFont={submitResponse[0].priceFont}
              data={submitResponse}
            />}
            {/*  */}

          </div>
          :
          <div ref={refToPrintBarcode} className={"p-3"}>محل نمایش بارکد</div>
      }
    </>)


});

export default ComponentToPrintBarcodeInEditSection;

